/**
 * @param {jQuery} $ jQuery object.
 */
(function( $ ) {
	
	/**
	 * Use labels as placeholders.
	 *
	 * @since 1.0.0
	 */
	var useLabelsAsPlaceholders = function() {
		var forms = [ 
			$( '.page--minimal .gform_wrapper form' ) 
		];

		$.each( forms, function(key, form) {
			var $form = form;

			$.each( $form.find( 'label' ), function() {
				var $label = $(this);
				var placeholder = $label.text();
				var $input = $( '#' + $label.attr( 'for' ) );

				if ( ! $input.length || $input.is( ':radio' ) || $input.is( ':checkbox' ) ) {
					return;
				}

				$input.attr( 'placeholder', placeholder );
				$label.addClass( 'screen-reader-text' );
			});
		});
	};

	/**
	 * Bind to the DOM
	 *
	 * @since 1.0.0
	 */
	$(document).ready(function() {

		useLabelsAsPlaceholders();

		/**
		 * When a popup opens.
		 *
		 * @since 1.0.0
		 */
		$(document).on( 'mfpOpen', function() {
			useLabelsAsPlaceholders();
		});

		/**
		 * When an AJAX popup opens.
		 *
		 * @since 1.0.0
		 */
		$(document).on( 'mfpAjaxContentAdded', function() {
			useLabelsAsPlaceholders();
		});
		
		$(".helpdesk-nav").mmenu({
        	extensions: ["widescreen"],
        	'navbar': {
				'add': false
			}
	    });
		
	});

})( jQuery );
